export const positionColor = {
  GK: "#f5a623",
  DF: "#4a90e2",
  MF: "#65f4a2",
  FW: "#ff4d5e"
};

export const categoryColors = {
  공지: "#00d166",
  경기: "#ff4d5e",
  모집: "#f5a623",
  운영: "#4a90e2"
};
